import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { ConsultorioHistoricoRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-historico.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class ConsultorioHistoricoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.consultorioPrivado.historicoConsulta;

    buscar(params: Pessoa & { idConsultorio: number }, context?: HttpContext): Observable<ConsultorioHistoricoRequest[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf).set('idConsultorio', params.idConsultorio);
        return this.http.get<ConsultorioHistoricoRequest[]>(this.PATH, { params: httpParams, context });
    }
}
